export class FilterResult {
  TotalCount: number;
  HasMoreItems: boolean;
  NextPage: string;
  PreviousPage: string;
  Results: any[];
}

/** describes how a search had to be reduced to keep every request below the query string budget */
export interface SearchLimitation {
  totalTermCount: number;
  usedTermCount: number;
  droppedTermCount: number;
  totalAttributeCount: number;
  usedAttributeCount: number;
  /** the contains phase (2nd) was not run */
  skippedContainsTier: boolean;
  /** the detailed phase (3rd, reordered or partial words) was needed but not run */
  skippedInexactTier: boolean;
  /** the query budget was lowered during this search because the server rejected a request */
  budgetReduced: boolean;
}

export class FilterResultWithState extends FilterResult {
  Finished: boolean = false;
  /** set when the search had to be limited; undefined when the full search was executed */
  Limitation?: SearchLimitation;
}

export class SkippedFilterResult extends FilterResult {
  TotalCount: number = 0;
  HasMoreItems: boolean = false;
  Results: any[] = [];
}
